import { memo } from 'react';

import { connect } from 'react-redux';
import { compose } from 'recompact';

import { chooseFlavor, errorBoundary, withLoading } from 'src/app/hocs';
import { getPaymentCard } from 'src/app/state/selectors';
import type { RootState } from 'src/app/state/store';

import RendererCheckout from './checkout';

import Renderer from '.';

function makeMapStateToProps() {
  return (state: RootState, { paymentCardId }: { paymentCardId: string }) => {
    const paymentCard = getPaymentCard(paymentCardId)(state);
    return {
      paymentCard,
      isLoading: paymentCard?.isFetching ?? false,
    };
  };
}

export default compose(
  errorBoundary,
  connect(makeMapStateToProps),
  withLoading,
  memo
)(
  chooseFlavor({
    default: Renderer,
    checkout: RendererCheckout,
  })
);
